export default __webpack_public_path__ + "static/media/logo-text.c0478014.svg";